// config.ts
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || "https://api.minnkotadr.com"; //"http://localhost:7224"; //"https://10.203.5.20:7224";
export const API_SCOPE_DOMAIN = "api://25dc2cac-5e76-4dd0-94ac-c3757257212c/";